var _linearGradient;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTriviumcolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95.337,
    height: 87.399,
    fill: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5ca2f3",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c374e1",
      stopOpacity: 1
    },
    offset: 1
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 5.047,
    y1: 6.117,
    x2: 77.075,
    y2: 54.136,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "url(#b)",
      fillOpacity: 1,
      InkscapeStroke: "none"
    },
    d: "m40.933 0 .06 6.5c-.122.002 2.509.677 5.075 2.373 2.565 1.697 5.46 4.232 7.775 7.303 4.631 6.142 7.182 13.859 1.678 23.393l5.629 3.25c6.783-11.75 3.554-23.033-2.118-30.555a38.524 38.524 0 0 0-9.38-8.812C46.495 1.364 43.964-.028 40.932 0ZM39.816 39.57l-5.63 3.25c6.586 11.407 17.91 14.304 27.288 13.383a39.6 39.6 0 0 0 12.42-3.34c3.43-1.57 5.954-2.943 7.513-5.61l-5.61-3.28c.105-.182-1.817 1.703-4.606 2.98-2.79 1.276-6.486 2.401-10.352 2.78-7.731.76-15.754-1.037-21.023-10.163Zm8.156-19.76c-13.445 0-21.573 8.64-25.29 17.463a40.511 40.511 0 0 0-3.032 12.742c-.266 3.838-.253 6.752 1.277 9.41l5.635-3.242c.073.127-.646-2.568-.428-5.719.218-3.15 1.005-7.027 2.54-10.668C31.74 32.513 37.18 26.31 47.971 26.31zm-.305 30.883c8.49 0 15.442-6.953 15.442-15.442S56.156 19.81 47.667 19.81s-15.44 6.952-15.44 15.441c0 8.49 6.951 15.442 15.44 15.442zm0-6.5a8.892 8.892 0 0 1-8.94-8.942 8.892 8.892 0 0 1 8.94-8.941 8.893 8.893 0 0 1 8.942 8.941 8.893 8.893 0 0 1-8.942 8.942zM18.224 0C4.33 0-4.527 15.344 2.419 27.375l29.444 51c6.946 12.032 24.665 12.032 31.61 0l29.444-51C99.864 15.345 91.005 0 77.113 0Zm0 6.5h58.889c9.201 0 14.776 9.657 10.175 17.625l-29.445 51c-4.6 7.97-15.75 7.97-20.352 0l-29.443-51C3.448 16.157 9.022 6.5 18.224 6.5Z"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriviumcolor);
export default __webpack_public_path__ + "static/media/triviumcolor.394c64d1fbc77e963f1f3f231c8fe09a.svg";
export { ForwardRef as ReactComponent };